/**
 * Gentle Strides AI Assistant Widget
 * Paste this whole file into a Shopify "Custom HTML" section,
 * wrapped in <script> tags, or upload it as a theme asset and
 * reference it with a <script src="..."> tag.
 *
 * Update BACKEND_URL below to point at your deployed server.js.
 */

(function () {
  const BACKEND_URL = "https://gentle-strides-ai-assistant-production.up.railway.app/api/chat";

  // ---- Styles ----
  const style = document.createElement("style");
  style.textContent = `
    #gs-chat-bubble {
      position: fixed; bottom: 20px; right: 20px; z-index: 9999;
      width: 60px; height: 60px; border-radius: 50%;
      background: #4a7c59; color: white; border: none; cursor: pointer;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      font-size: 26px; display: flex; align-items: center; justify-content: center;
    }
    #gs-chat-window {
      position: fixed; bottom: 92px; right: 20px; z-index: 9999;
      width: 340px; max-width: 90vw; height: 460px; max-height: 70vh;
      background: white; border-radius: 12px; box-shadow: 0 8px 30px rgba(0,0,0,0.25);
      display: none; flex-direction: column; overflow: hidden;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    }
    #gs-chat-header {
      background: #4a7c59; color: white; padding: 14px 16px;
      font-weight: 600; font-size: 15px;
    }
    #gs-chat-messages {
      flex: 1; overflow-y: auto; padding: 12px; background: #f7f7f5;
    }
    .gs-msg { margin-bottom: 10px; max-width: 85%; padding: 8px 12px; border-radius: 12px; font-size: 14px; line-height: 1.4; }
    .gs-msg-user { background: #4a7c59; color: white; margin-left: auto; border-bottom-right-radius: 3px; }
    .gs-msg-bot { background: #eaeae6; color: #222; margin-right: auto; border-bottom-left-radius: 3px; }
    #gs-chat-input-row { display: flex; border-top: 1px solid #eee; }
    #gs-chat-input {
      flex: 1; border: none; padding: 12px; font-size: 14px; outline: none;
    }
    #gs-chat-send {
      background: #4a7c59; color: white; border: none; padding: 0 16px; cursor: pointer; font-size: 14px;
    }
    #gs-chat-send:disabled { opacity: 0.5; cursor: default; }
  `;
  document.head.appendChild(style);

  // ---- Markup ----
  const bubble = document.createElement("button");
  bubble.id = "gs-chat-bubble";
  bubble.innerHTML = "🐾";
  bubble.setAttribute("aria-label", "Open chat assistant");

  const chatWindow = document.createElement("div");
  chatWindow.id = "gs-chat-window";
  chatWindow.innerHTML = `
    <div id="gs-chat-header">Ask us anything 🐾</div>
    <div id="gs-chat-messages"></div>
    <div id="gs-chat-input-row">
      <input id="gs-chat-input" type="text" placeholder="e.g. Which ramp fits a 40lb dog?" />
      <button id="gs-chat-send">Send</button>
    </div>
  `;

  document.body.appendChild(bubble);
  document.body.appendChild(chatWindow);

  const messagesEl = chatWindow.querySelector("#gs-chat-messages");
  const inputEl = chatWindow.querySelector("#gs-chat-input");
  const sendBtn = chatWindow.querySelector("#gs-chat-send");

  let history = [];
  let opened = false;

  function addMessage(text, sender) {
    const div = document.createElement("div");
    div.className = `gs-msg gs-msg-${sender}`;
    div.textContent = text;
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function greetIfFirstOpen() {
    if (!opened) {
      opened = true;
      addMessage(
        "Hi! I can help you find the right product for your dog, or answer questions about senior dog mobility. What's going on with your pup?",
        "bot"
      );
    }
  }

  bubble.addEventListener("click", () => {
    const isOpen = chatWindow.style.display === "flex";
    chatWindow.style.display = isOpen ? "none" : "flex";
    if (!isOpen) greetIfFirstOpen();
  });

  async function sendMessage() {
    const text = inputEl.value.trim();
    if (!text) return;

    addMessage(text, "user");
    history.push({ role: "user", content: text });
    inputEl.value = "";
    sendBtn.disabled = true;

    const typingEl = document.createElement("div");
    typingEl.className = "gs-msg gs-msg-bot";
    typingEl.textContent = "...";
    messagesEl.appendChild(typingEl);
    messagesEl.scrollTop = messagesEl.scrollHeight;

    try {
      const res = await fetch(BACKEND_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: history }),
      });
      const data = await res.json();
      typingEl.remove();

      const reply = data.reply || "Sorry, something went wrong. Please try again.";
      addMessage(reply, "bot");
      history.push({ role: "assistant", content: reply });
    } catch (err) {
      typingEl.remove();
      addMessage("Sorry, I'm having trouble connecting. Please try again in a moment.", "bot");
    } finally {
      sendBtn.disabled = false;
      inputEl.focus();
    }
  }

  sendBtn.addEventListener("click", sendMessage);
  inputEl.addEventListener("keydown", (e) => {
    if (e.key === "Enter") sendMessage();
  });
})();
